const state = {
  persons: [],
  candidates: [],
  person: {},
}
export default state
